// extracted by mini-css-extract-plugin
module.exports = {"Content":"MobileHeader_Content__idFyp","Navigation":"MobileHeader_Navigation__s5LRg","Title":"MobileHeader_Title__ULrQW"};